import { useMutation } from "react-query";
import { addDistributionChannel } from "../../../../../actions/Utilities/DistributionChannel";

const useAddistributionChannel = () => {
  return useMutation(addDistributionChannel);
};
export default useAddistributionChannel;
